import {
  AuthMeResponseSchema,
  AuthSessionResponseSchema,
  LoginBodySchema,
  type AuthMeResponse,
  type LoginBody,
} from '@zrsystem/contracts';

import { getHttpClient } from '@/shared/api/http-client.js';

export async function loginRequest(body: LoginBody) {
  const payload = LoginBodySchema.parse(body);
  const response = await getHttpClient().post<unknown>('/api/auth/login', payload, {
    skipAuth: true,
  });
  return AuthSessionResponseSchema.parse(response);
}

export async function refreshSessionRequest() {
  const response = await getHttpClient().post<unknown>(
    '/api/auth/refresh',
    {},
    { skipAuth: true, skipPlace: true },
  );
  return AuthSessionResponseSchema.parse(response);
}

export async function fetchCurrentUser(): Promise<AuthMeResponse> {
  const response = await getHttpClient().get<unknown>('/api/auth/me');
  return AuthMeResponseSchema.parse(response);
}
